export async function removeBranch(api,siteId,rootId,onStep=()=>{}){
  const nested=await api.children(siteId,rootId)
  if(nested.length)throw new Error('Remove or move this branch’s child sites first.')

  const [domainRows,deploymentPage]=await Promise.all([
    api.domains(siteId,rootId),
    api.deployments(siteId,rootId),
  ])

  if(deploymentPage.items.some(item=>item.status==='active')){
    onStep('Deactivating the active deployment')
    await api.deactivateDeployment(siteId,rootId)
  }

  for(const domain of domainRows){
    onStep(`Releasing ${domain.hostname}`)
    await api.releaseDomain(siteId,rootId,domain.id)
  }

  const refreshedDeployments=await api.deployments(siteId,rootId)
  for(const deployment of refreshedDeployments.items){
    onStep(`Deleting deployment ${deployment.id.slice(0,12)}`)
    await api.deleteDeployment(siteId,rootId,deployment.id)
  }

  const refreshedBuilds=await api.builds(siteId,rootId)
  const inFlight=refreshedBuilds.items.filter(item=>['queued','running'].includes(item.status))
  if(inFlight.length)throw new Error('A build is still queued or running. Wait for it to finish, then remove this branch.')
  for(const build of refreshedBuilds.items){
    onStep(`Deleting build ${build.id.slice(0,12)}`)
    await api.deleteBuild(siteId,rootId,build.id)
  }

  onStep('Archiving the branch site')
  await api.archiveSite(siteId,rootId)
  onStep('Permanently deleting the archived branch record')
  await api.purgeSite(siteId,rootId)
  return{domains:domainRows.length,deployments:refreshedDeployments.items.length,builds:refreshedBuilds.items.length,purged:true}
}

export async function removeAllBuilds(api,siteId,rootId){
  const page=await api.builds(siteId,rootId)
  const inFlight=page.items.filter(item=>['queued','running'].includes(item.status))
  if(inFlight.length)throw new Error('Queued or running builds cannot be deleted.')
  for(const build of page.items)await api.deleteBuild(siteId,rootId,build.id)
  return page.items.length
}

export async function removeAllDeployments(api,siteId,rootId){
  const page=await api.deployments(siteId,rootId)
  if(page.items.some(item=>item.status==='active'))await api.deactivateDeployment(siteId,rootId)
  const refreshed=await api.deployments(siteId,rootId)
  for(const deployment of refreshed.items)await api.deleteDeployment(siteId,rootId,deployment.id)
  return refreshed.items.length
}

export async function releaseAllDomains(api,siteId,rootId){
  const rows=await api.domains(siteId,rootId)
  for(const domain of rows)await api.releaseDomain(siteId,rootId,domain.id)
  return rows.length
}
